var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.483,
    height: 10.173,
    viewBox: "0 0 20.483 10.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(-562.882 -1255.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M572.207,1255.052H563.7a.864.864,0,0,0-.818.9v2.344a.818.818,0,1,0,1.625.011v-1.43h2.636v6.518h-1.318a.919.919,0,0,0,.024,1.828h4.237a.918.918,0,0,0,.806-1,.919.919,0,0,0-.83-.83h-1.294v-6.518H571.4v1.419a.869.869,0,0,0,.824.913.865.865,0,0,0,.8-.9v-2.344A.867.867,0,0,0,572.207,1255.052Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    d: "M576.368,1255.116h6.105a.892.892,0,0,1,.892.892h0a.892.892,0,0,1-.892.892h-6.105a.892.892,0,0,1-.892-.892h0A.892.892,0,0,1,576.368,1255.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    d: "M576.368,1263.441h6.105a.892.892,0,0,1,.892.892h0a.891.891,0,0,1-.892.892h-6.105a.891.891,0,0,1-.892-.892h0A.892.892,0,0,1,576.368,1263.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    d: "M576.368,1259.279h6.105a.892.892,0,0,1,.892.892h0a.892.892,0,0,1-.892.892h-6.105a.892.892,0,0,1-.892-.892h0A.892.892,0,0,1,576.368,1259.279Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleText);
export default __webpack_public_path__ + "static/media/toggle-text.a0c05781fc3aada2a65ca255a27367f6.svg";
export { ForwardRef as ReactComponent };